export const timeLimitOptions = [
  { label: "Minutes", value: 60 },
  { label: "Hours", value: 3600 },
]
